module.exports = "/_next/static/images/e5cc0cd388b3686fda5769ba7109151a-mastercard-right-small.jpg.webp";